<template>
    <el-dialog
        title="选择服务商"
        :visible.sync="dialogVisible"
        width="1200px" class="facilitatorDialogBox">
        <div class="facilitatorDialog">
            <div class="search">
                <ul class="searchLeft">
                    <li :class="searchActive === item.id?'active':''"
                        v-for="(item,index) in searchList" :key="index"
                        @click="searchOrder(item)">
                        {{item.name}} <i v-if="item.id === '0'" class="el-icon-caret-bottom"></i>
                    </li>
                </ul>
                <div class="searchRight">
                    <div class="area">
                        <div class="name">地区</div>
                        <el-cascader clearable
                            v-model="regionValue"
                            @change="handleChange"
                            :options="regionOptions"
                            placeholder="省/市/区"
                            style="width: 200px;"
                        ></el-cascader>
                    </div>
                    <el-input
                        placeholder="请输入检索关键字"
                        v-model="storeName" clearable style="width: 200px;">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="searchInfo"></i>
                    </el-input>
                </div>
            </div>
            <div class="facilitatorContent">
                <div class="facilitatorHeader">
                    <div class="name">服务商</div>
                    <div class="materials">材料</div>
                    <div class="price">价格</div>
                    <div class="deliveryTime">预计发货时间</div>
                </div>
                <div class="facilitatorTable">
                    <el-scrollbar style="height: 500px">
                        <div class="tableItem" v-for="item in facilitatorList" :key="item.uuid">
                            <div class="name" style="cursor: pointer;" @click="getProviders(item)">
                                <div class="logo">
                                    <img :src="item.storeLogo" alt="">
                                </div>
                                <div class="info">
                                    <div class="name">{{item.storeName}}</div>
                                    <div class="location">
                                        <i class="el-icon-location"></i>
                                        <span>{{item.detailAddress}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="materials">
                                <el-radio-group v-model="item.checked" @change="materialsSelect(item)" v-if="userUuid==item.userUuid">
                                    <el-radio :label="radio.uuid"
                                              disabled
                                              v-for="(radio,index) in item.managerList"
                                              :key="index">{{ radio.materialName }}
                                    </el-radio>
                                </el-radio-group>
                                <el-radio-group v-model="item.checked" @change="materialsSelect(item)" v-else>
                                    <el-radio :label="radio.uuid"
                                              v-for="(radio,index) in item.managerList"
                                              :key="index">{{ radio.materialName }}
                                    </el-radio>
                                </el-radio-group>
                            </div>
                            <div class="price">
                                <div class="priceItem" v-for="(price,index) in item.managerList" :key="index"><span>{{ price.unitPrice }}</span>元/克
                                </div>
                            </div>
                            <div class="price" style="width: 250px;">
                                <div class="priceItem" v-for="(time,index) in item.managerList" :key="index">{{ time.sendCycleMin }}-{{ time.sendCycleMax }}天
                                </div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
            <div class="buttonGroup">
                <el-button size="medium" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" size="medium" @click="selectSubmit">选择</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import provinceData from "../../utils/provinceData";
    import { getPrintProvidersList,getNewcurrent } from '../../utils/interface';
    export default {
        name: "facilitatorDialog",
        data() {
            return {
                dialogVisible: false,
                searchActive: '0',
                searchList: [
                    {
                        id: '0',
                        value: '',
                        name: '默认'
                    },
                    {
                        id: '1',
                        value: 'volume_descend',
                        name: '人气'
                    },
                    {
                        id: '2',
                        value: 'price_descend',
                        name: '价格'
                    },
                ],
                searchValue: '',
                regionValue: '',
                regionOptions: provinceData,
                facilitatorList: [],
                technologyUuid:"",
                materialUuid:"",
                soildUuid:"",
                storeName:"",
                storeCity:"",
                isReprocess:"",
                userUuid:"",
                orderBy:"",
            }
        },
        methods: {
            getProviders(msg){
                let routeData = this.$router.resolve({
                    name: "printServiceIndex",
                    params: { enterPriseId: msg.enterPriseId },
                });
                window.open(routeData.href, "_blank");
            },
            init(technologyUuid,materialUuid,soildUuid,isReprocess) {
                this.technologyUuid = technologyUuid;
                this.materialUuid = materialUuid[1];
                this.soildUuid = soildUuid==true?'YES':'NO';
                // 不需要后处理，但是支持后处理的行业也可以做不是后处理的数据
                if(!isReprocess){
                    this.isReprocess = "";
                }else{
                    this.isReprocess = isReprocess==true?'YES':'NO';
                }
                this.getPrintProvidersList();
                this.getUserInfo();
            },
            getUserInfo(){
                getNewcurrent().then((res) => {
                    this.userUuid = res.uuid;
                });
            },
            getPrintProvidersList(){
                let params = {
                    technologyUuid:this.technologyUuid,
                    materialUuid:this.materialUuid,
                    isHollow:this.soildUuid=='YES'?'YES':'',
                    storeCity:this.storeCity,
                    storeName:this.storeName,
                    isReprocess:this.isReprocess,
                    orderBy:this.orderBy,
                };
                getPrintProvidersList(params).then((res)=>{
                    res.data.map(item => {
                        item.checked = false;
                    });
                    this.facilitatorList = res.data;
                    this.dialogVisible = true;
                });
            },
            handleChange(value) {
                this.storeCity = "";
                if(value != null && value.length == 3){
                    this.storeCity = value[0]+","+value[1]+","+value[2];
                } else if(value != null && value.length == 2){
                    this.storeCity = value[0]+","+value[1];
                }
                this.getPrintProvidersList();
            },
            searchOrder(item){
                this.searchActive = item.id;
                this.orderBy = item.value;
                this.searchInfo();
            },
            searchInfo(){
                this.getPrintProvidersList();
            },
            // 选择服务商材料
            materialsSelect(val) {
                this.facilitatorList.map(item => {
                    if (val.uuid !== item.uuid) {
                        item.checked = false
                    }
                });
            },
            // 选择服务商提交
            selectSubmit() {
                let val = this.facilitatorList.filter(res => {
                    return res.checked !== '' && res.checked !== false && res.checked !== null && res.checked !== undefined
                });
                if (val.length <= 0) {
                    this.$message.warning('请选择服务商')
                } else {
                    let materialsInfo = val[0].managerList.filter(res=> {return res.uuid === val[0].checked});
                    let endData = {
                        uuid: val[0].uuid,
                        storeLogo:val[0].storeLogo,
                        storeName: val[0].storeName,
                        detailAddress: val[0].detailAddress,
                        managerList:materialsInfo
                    };
                    this.$emit('selectFacilitator', endData);
                    this.dialogVisible = false
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .facilitatorDialogBox {
        /deep/ .el-dialog__header {
            border-bottom: 1px solid #ddd;
        }
        
        /deep/ .el-dialog__body {
            padding: 0;
        }
        
        .search {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 15px;
            
            .searchLeft {
                display: flex;
                
                li {
                    width: 80px;
                    text-align: center;
                    cursor: pointer;
                    
                    &.active {
                        color: #409EFF;
                    }
                    
                    &:hover {
                        color: #409EFF;
                    }
                }
            }
            
            .searchRight {
                display: flex;
                
                .area {
                    display: flex;
                    margin-right: 15px;
                    align-items: center;
                    
                    .name {
                        min-width: 40px;
                    }
                }
            }
        }
        
        .facilitatorContent {
            .facilitatorHeader {
                display: flex;
                height: 54px;
                background: rgba(0, 0, 0, .02);
                line-height: 54px;
                font-weight: 400;
                color: #000000;
                font-size: 14px;
                padding: 0 24px;
            }
            
            .tableItem {
                padding: 24px;
                display: flex;
                border-bottom: 1px dashed #ddd;
                
                .name {
                    text-align: left;
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #333;
                    
                    .logo {
                        width: 190px;
                        height: 90px;
                        margin-right: 20px;
                        
                        img {
                            width: 190px;
                            height: 90px;
                            border: 1px solid rgba(0, 0, 0, 0.15);
                        }
                    }
                }
                
                /deep/ .el-radio {
                    display: block;
                    margin: 0;
                    padding: 10px 0;
                }
                
                .priceItem {
                    padding: 8px 0;
                    font-size: 14px;
                    
                    span {
                        color: #E50000;
                        padding-right: 5px;
                    }
                }
            }
            
            /deep/ .el-scrollbar__wrap {
                overflow-x: hidden;
            }
            
            .name {
                text-align: center;
                flex: 1;
            }
            
            .materials {
                width: 200px;
                text-align: center;
            }
            
            .price {
                width: 200px;
                text-align: center;
            }
            
            .deliveryTime {
                width: 250px;
                text-align: center;
            }
        }
        
        .buttonGroup {
            text-align: right;
            height: 52px;
            border-top: 1px solid #ddd;
            line-height: 52px;
            padding: 0 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/print/facilitatorDialog.vue